import { render, staticRenderFns } from "./CommitteeLinkList.vue?vue&type=template&id=3bf6cae4"
import script from "./CommitteeLinkList.vue?vue&type=script&lang=js"
export * from "./CommitteeLinkList.vue?vue&type=script&lang=js"
import style0 from "./CommitteeLinkList.vue?vue&type=style&index=0&id=3bf6cae4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports